module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-red-4a1f8bb6e754836ce011da625b87cce4.png";